import { DEFAULT_LANG, LANGUAGE } from '@/constants'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useInputPlaceholder = (...args: Parameters<typeof useTranslation>) => {
  const { t } = useTranslation(...args)

  return {
    t: (label: string) =>
      t('common.placeholder', {
        label: t(label),
      }),
  }
}

const LANGUAGE_MAP = new Map(LANGUAGE.map((it) => [it.lang, it]))

export const useCurrentLanguage = () => {
  const { i18n } = useTranslation()
  return LANGUAGE_MAP.get(i18n.language) ?? LANGUAGE_MAP.get(DEFAULT_LANG)
}

/**
 * 如果翻译为空或者等于key，则使用fallback
 * @returns
 */
export const useFallbackT = () => {
  const { t } = useTranslation()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback((fallback: string, ...args: Parameters<typeof t>) => fallbackT(t, fallback, ...args), [t])
}

/**
 * 如果翻译为空或者等于key，则使用fallback
 * @param t
 * @returns
 */
export function fallbackT(t: (...args: any) => string, fallback: string, ...args: Parameters<typeof t>) {
  let desc = t(...args)
  if (!desc || desc === args[0]) desc = fallback
  return desc
}
